import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { brandTheme } from '../../types/BrandTheme'
import { merge } from 'theme-ui'
import { dirname } from 'path'
import {
  resolveFontFamily,
  resolveThemeUIFontSizes,
} from '@jotta/ui/FontConfig'

import './theme.css'

export const teliacloudtheme: BrandTheme = merge.all<
  BrandTheme,
  PartialBrandTheme
>(brandTheme, {
  branding: {
    brand: 'TELIA_CLOUD',
    themedir: dirname(new URL(import.meta.url).pathname),
    appIconSvg: './appicon.svg',
    favIconSvg: './favicon.svg',
    staticDir: 'telia_cloud',
    height: 32,
    learnMoreLinkWaitlist: 8413864,
    learnMoreLinkSearch: 8414204,
  },
  radii: [0, 2, 4, 10],
  fontSizes: resolveThemeUIFontSizes('teliacloud'),
  fonts: resolveFontFamily('teliacloud'),
  fontWeights: {
    light: 300,
    body: 400,
    heading: 700,
    bold: 700,
  },
  colors: {
    text: '#222',
    textOpacity: 'rgba(34, 34, 34, 0.8)',
    background: '#fff',
    primary: '#29003e',
    secondary: '#f2f2f2',
    secondaryText: '#222',
    accent: '#29003e',
    accentText: '#fff',
    focus: '#990AE3',
    focusDark: '#990AE3',
    border: '#DDD',
    danger: '#e4175c',
    gray: '#928d89',
    purple: '#927ece',
    activeBreadcrumb: '#990AE3',
  },
  buttons: {
    primary: {
      color: 'accentText',
      borderColor: 'accent',
      backgroundColor: 'accent',
      borderRadius: '2rem',
      letterSpacing: '0.5px',
      fontSize: 1,
      lineHeight: '1',
      py: '1rem',
      px: '1.8rem',
      fontWeight: 'body',
      textTransform: 'uppercase',
      transition: 'all 300ms',
      '&:not(:disabled):hover': {
        filter: 'brightness(1.1)',
        opacity: 1,
      },
      '> svg': {
        mb: '-8px',
        position: 'relative',
        top: '-4px',
      },
    },
    secondary: {
      variant: 'buttons.primary',
      color: 'secondaryText',
      borderColor: 'secondary',
      backgroundColor: 'secondary',
      '&:not(:disabled):hover': {
        filter: 'brightness(0.9)',
        opacity: 0.9,
      },
    },
    plain: {
      textTransform: 'initial',
    },
    error: {
      '&:not(:disabled):hover': {
        filter: 'brightness(1.1)',

        backgroundColor: 'danger',
        color: 'dangerText',
      },
    },
    download: {
      backgroundColor: 'background',
    },
    languageSelector: {
      '> svg': {
        mb: 0,
        top: 0,
        width: '24px',
        height: '24px',
      },
    },
    danger: {
      color: '#ef3138',
    },
    replyButton: {
      color: 'var(--color-primary)',
    },
    replyButtonDarkMode: {
      color: 'background',
    },
  },
  forms: {
    input: {
      border: '1px solid',
      borderColor: 'border',
      borderRadius: 2,
      px: 3,
      py: '0.75rem',
      '&:focus': {
        borderColor: 'primary',
      },
      '&:disabled': {
        backgroundColor: 'lightGray',
      },
    },
    toggle: {
      '&:checked::before': {
        backgroundColor: 'primary',
      },
      '&:checked::after': {
        backgroundColor: 'primary',
      },
    },
    checkbox: {
      fontSize: '11px',
      borderRadius: '3px',
      border: '1px solid',
    },
  },
  layout: {
    appHeaderHamburger: {
      color: 'text',
      '> svg': {
        color: 'text',
        opacity: 1,
      },
    },
  },
  cards: {
    photoUploadSuccess: {
      '--action-button-text-opacity': 1,
    },
    photoUpload: {
      '--action-button-text-opacity': 1,
    },
  },
  styles: {
    avatar: {
      borderRadius: '100%',
      fontSize: 1,
      fontWeight: 'body',
      width: '36px',
      height: '36px',
      lineHeight: '36px',
    },
    h1: {
      color: '#4A4A4A',
      fontSize: '23px',
    },
    h2: {
      fontSize: '17px',
      fontFamily: 'heading',
      marginBottom: '19px',
      padding: 0,
      color: '#45434C',
      lineHeight: '24px',
    },
    h3: {
      fontFamily: 'TeliaSans',
    },
    h4: {
      color: '#4A4A4A',
      fontWeight: 'heading',
    },
    p: {
      color: '#45434C',
      fontSize: 2,
    },
    //Used on download page
    downloadPageHeader: {
      color: 'black',
    },
    downloadSvg: {
      color: 'black',
    },
    fileIcon: {
      '--file-icon-border-color': '#222',
    },
    newAlbumP: {
      opacity: 0.8,
    },
    addMoreSvg: {
      fontSize: 5,
    },
    albumListHeading: {
      fontWeight: 500,
      fontSize: 4,
    },
    timelineHeading: {
      textTransform: 'uppercase',
      fontSize: 4,
    },
  },
})
export default teliacloudtheme
